import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { guardarBeforeInstallPrompt, marcarInstalado } from './lib/app'
import { mostrarToast } from './lib/formularioGuiado'
import { ehErroDeSessaoInvalida, ehRefreshTokenInvalido, descartarSessaoAntiga } from './lib/sessao'

// Endereço único: o site só existe em www.seligacatolico.com.br. Redireciona o
// apex (sem www) antes de qualquer outra coisa, para o Android tratar o app
// instalado e os links de divulgação como a mesma origem. Não vale para o
// localhost nem para o preview do Readdy.
if (location.hostname === 'seligacatolico.com.br') {
  location.replace(
    'https://www.seligacatolico.com.br' +
      location.pathname +
      location.search +
      location.hash,
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Captura o beforeinstallprompt cedo, antes de qualquer tela montar.
// É ele que permite o botão "Instalar" no Android/Chrome.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  guardarBeforeInstallPrompt(e);
});

// Quando o app é instalado, marca para nunca mais convidar.
window.addEventListener('appinstalled', () => {
  marcarInstalado();
  mostrarToast('Instalado! Abrindo o Se Liga…');
});

// Registra o service worker (avisos push) só em produção. Não bloqueia a
// renderização e nunca cacheia página — o site sempre busca a versão nova.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${__BASE_PATH__}sw.js`)
      .catch(() => {
        // Silencioso: sem o service worker os avisos ficam indisponíveis,
        // mas o site segue funcionando normalmente.
      });
  });
}

// Sessões antigas guardadas no navegador (token de atualização que já não
// existe no servidor) fazem a biblioteca de login disparar um erro assíncrono
// que apareceria como falha na tela. Reconhecemos esse caso específico e o
// silenciamos. Não deslogamos ninguém nem mandamos para o login: a sessão segue
// como está e, se realmente acabou, o próprio Supabase avisa via SIGNED_OUT.
window.addEventListener('unhandledrejection', (e) => {
  // Sessão guardada que já não existe no servidor: apagamos o resto velho do
  // navegador para o erro parar de repetir. Ninguém é mandado para o login.
  if (ehRefreshTokenInvalido(e.reason)) {
    e.preventDefault()
    void descartarSessaoAntiga()
    return
  }
  if (ehErroDeSessaoInvalida(e.reason)) {
    e.preventDefault()
  }
});